'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _jsx = require('@babel/runtime/helpers/jsx');
var React = require('react');
var classNames = require('classnames');
var context = require('@andes/context');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
const namespace = 'andes-carousel-free';
const slideNamespace = "".concat(namespace, "__slide");
const CarouselFree = /*#__PURE__*/function () {
  const CarouselFree = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
      'aria-label': ariaLabel,
      children,
      className,
      id,
      innerRef,
      spacing = 12,
      srLabel
    } = _ref;
    const componentId = context.useId(id);
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: namespace,
      ref: ref || innerRef,
      id: componentId
    }, /*#__PURE__*/_jsx__default["default"]("ul", {
      "aria-label": srLabel || ariaLabel,
      className: classNames__default["default"]("".concat(namespace, "__list"), "".concat(namespace, "__list--spacing-").concat(spacing), className)
    }, void 0, children));
  });
  CarouselFree.displayName = 'CarouselFree';
  return CarouselFree;
}();
var CarouselFree$1 = CarouselFree;
const CarouselFreeSlide = /*#__PURE__*/function () {
  const CarouselFreeSlide = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
      children,
      className,
      component: Component = 'li'
    } = _ref;
    return /*#__PURE__*/React__default["default"].createElement(Component, {
      className: classNames__default["default"]("".concat(slideNamespace), className),
      ref: ref
    }, children);
  });
  CarouselFreeSlide.displayName = 'CarouselFreeSlide';
  return CarouselFreeSlide;
}();
var CarouselFreeSlide$1 = CarouselFreeSlide;
exports.CarouselFree = CarouselFree$1;
exports.CarouselFreeSlide = CarouselFreeSlide$1;
exports["default"] = CarouselFree$1;
